var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_vm._t("default",function(){return [_vm._v("\n    No Filter define\n  ")]},{"query":_vm.query})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }